import AppOptions from "../app/options";
import GQL from "../gql/gql";
import Html from "./html";
import User from "./user";
import Banners from "./banners";

declare var window: any;

class Comments {

    constructor(
        private html: Html,
        private gql: GQL,
        private user: User,
        private banners: Banners,
        private options: AppOptions
    ) { }

    loadMore(): void {
        const comments = this.html.qAll('#comments .comment:not(.comment-reply)');
        let lastCommentId = '-';

        if (comments.length) {
            const lastComment = comments[comments.length - 1] as HTMLElement;
            lastCommentId = lastComment.dataset.commentId || '';
        }

        const url = '/articles/' + this.options.articleId +
            '/comments/from_comment_id/' + lastCommentId;

        this.html.fetchText(url)
            .then(html => {
                this.html.appendHTML('#comments_placeholder', html);
                if (!html || html.length < 40) {
                    this.html.hide('#comments_load_more');
                }

                this.banners.comments();
            });
    }

    toggleReplyForm(commentId: string): void {
        if (!this.user.user) {
            return this.user.goLogin();
        }

        const selector = '#comment_' + commentId;

        this.html.toggleClass(selector, 'show-reply');
    }

    hideReplyForm(commentId: string): void {
        this.html.removeClass('#comment_' + commentId, 'show-reply');
    }

    reply(parentCommentId: string, commentId: string): void {
        const selector = '#comment_' + commentId + ' .comment-reply-form textarea';
        const e = this.html.q(selector) as HTMLTextAreaElement;
        const text = e?.value;

        if (!e || !text) {
            return;
        }

        this.gql.commentAdd(this.options.articleId, text, parentCommentId)
            .then(r => this.afterReply(parentCommentId, commentId, text, r, e))
            .catch(err => this.onReplyError(err, commentId));
    }

    private onReplyError(err: Error, commentId: string) {
        const selector = '#comment_' + commentId + ' .comment-reply-error';
        const selectorText = selector + ' .error-message';

        this.html.writeHTML(selectorText, err.message);
        this.html.show(selector, 'flex');

        setTimeout(() => {
            this.html.writeHTML(selectorText, '');
            this.html.hide(selector);
        }, 4000);
    }

    voteUp(commentId: string): void {
        this.gql.commentVoteUp(this.options.articleId, commentId)
            .then(r => this.afterVote(commentId, r, 'up'))
            .catch(err => this.onVoteError(err, commentId));
    }

    voteDown(commentId: string): void {
        this.gql.commentVoteDown(this.options.articleId, commentId)
            .then(r => this.afterVote(commentId, r, 'down'))
            .catch(err => this.onVoteError(err, commentId));
    }

    private onVoteError(err: Error, commentId: string): void {
        const selector = '#comment_' + commentId + ' .comment-likes-error';
        const selectorText = selector + ' .error-message';

        this.html.writeHTML(selectorText, err.message);
        this.html.show(selector, 'flex');

        setTimeout(() => {
            this.html.writeHTML(selectorText, '');
            this.html.hide(selector);
        }, 4000);
    }

    private afterVote(commentId: string, r: any, direction: string): void {
        // Increase vote count
        const cssCass = direction === 'up' ? '.comment-likes-positive' : '.comment-likes-negative';
        const selector = '#comment_' + commentId + ' ' + cssCass;

        const e = this.html.q(selector);

        if (!e) {
            return;
        }

        const nbLikes = parseInt(e.innerHTML, 10) + 1;

        this.html.writeHTML(selector, '' + nbLikes);
    }

    private afterReply(parentCommentId: string, commentId: string, text: string, r: any, e: HTMLTextAreaElement): void {
        e.value = '';

        if (commentId) {
            this.hideReplyForm(commentId);
            setTimeout(() => this.reloadComment(parentCommentId), 500);
        } else {
            const newCommentId = r.id;
            setTimeout(() => this.injectComment(newCommentId), 500);
        }
    }

    private injectComment(commentId: string): void {
        const url = '/articles/' + this.options.articleId + '/comments/' + commentId;

        this.html.fetchText(url)
            .then(html => this.html.prependHTML('#comments_placeholder', html));
    }

    private reloadComment(commentId: string): void {
        const selector = '#comment_' + commentId + '_thread';
        this.html.addClass(selector, 'reloading');

        const url = '/articles/' + this.options.articleId + '/comments/' + commentId;

        this.html.fetchText(url)
            .then(html => this.html.writeHTML(selector, html));
    }
}

export default Comments;